const _import = require('./_import_' + process.env.NODE_ENV)

import { RouteDefines } from '@/utils/defines'
import Layout from '@/views/layout/menu'

export const RouterMenuList = [
  // 首页
  {
    name: RouteDefines.ROUTER_NAME_HOME,
    path: '/',
    redirect: '/home',
    component: Layout,
    meta: {
      hasSubMenu: false,
      title: '首页',
      icon: 'icon-guanli',
      level: 1
    },
    children: [
      {
        name: RouteDefines.ROUTER_NAME_HOME_DASHBOARD,
        path: '/home',
        meta: {
          title: '首页看板',
          level: 2,
          menu_id: 10001,
          parent_name: RouteDefines.ROUTER_NAME_HOME
        },
        component: _import('home/index')
      }
    ]
  },
  // 提现管理
  {
    name: RouteDefines.ROUTER_NAME_WITHDRAW_HOME,
    path: '/withdraw',
    redirect: '/withdraw',
    component: Layout,
    meta: {
      hasSubMenu: false,
      title: '提现管理',
      icon: 'icon-guanli',
      level: 1
    },
    children: [
      {
        name: RouteDefines.ROUTER_NAME_WITHDRAW_LIST,
        path: '/withdraw',
        meta: {
          title: '提现管理',
          level: 2,
          menu_id: 10002,
          parent_name: RouteDefines.ROUTER_NAME_WITHDRAW_HOME
        },
        component: _import('withdraw/index')
      }
    ]
  },
  // 店铺管理
  {
    name: RouteDefines.ROUTER_NAME_SHOP_HOME,
    path: '/shop',
    redirect: '/shop',
    component: Layout,
    meta: {
      hasSubMenu: false,
      title: '店铺管理',
      icon: 'icon-guanli',
      level: 1
    },
    children: [
      {
        name: RouteDefines.ROUTER_NAME_SHOP_LIST,
        path: '/shop',
        meta: {
          title: '店铺管理',
          level: 2,
          menu_id: 10003,
          parent_name: RouteDefines.ROUTER_NAME_SHOP_HOME
        },
        component: _import('shop/index')
      }
    ]
  },
  // 在线收支
  {
    name: RouteDefines.ROUTER_NAME_ONLINE_TRADE_HOME,
    path: '/trade/online',
    redirect: '/trade/online',
    component: Layout,
    meta: {
      hasSubMenu: false,
      title: '在线收支',
      icon: 'icon-guanli',
      level: 1
    },
    children: [
      {
        name: RouteDefines.ROUTER_NAME_ONLINE_TRADE_LIST,
        path: '/trade/online',
        meta: {
          title: '在线收支',
          level: 2,
          menu_id: 10004,
          parent_name: RouteDefines.ROUTER_NAME_ONLINE_TRADE_HOME
        },
        component: _import('trade/online')
      }
    ]
  },
  // 账号管理
  {
    name: RouteDefines.ROUTER_NAME_OPERATOR_HOME,
    path: '/operator',
    redirect: '/operator',
    component: Layout,
    meta: {
      hasSubMenu: false,
      title: '账号管理',
      icon: 'icon-guanli',
      level: 1
    },
    children: [
      {
        name: RouteDefines.ROUTER_NAME_OPERATOR_LIST,
        path: '/operator',
        meta: {
          title: '账号管理',
          level: 2,
          menu_id: 10005,
          parent_name: RouteDefines.ROUTER_NAME_OPERATOR_HOME
        },
        component: _import('operator/index')
      }
    ]
  },
  // 修改密码
  {
    name: RouteDefines.ROUTER_NAME_PASSWORD_HOME,
    path: '/password',
    redirect: '/password',
    component: Layout,
    meta: {
      hasSubMenu: false,
      hidden: true,
      title: '修改密码',
      icon: 'icon-guanli',
      level: 1
    },
    children: [
      {
        name: RouteDefines.ROUTER_NAME_PASSWORD_INDEX,
        path: '/password',
        meta: {
          title: '修改密码',
          level: 2,
          menu_id: 10006,
          parent_name: RouteDefines.ROUTER_NAME_OPERATOR_HOME
        },
        component: _import('operator/password')
      }
    ]
  },
  // 续期订单
  {
    name: RouteDefines.ROUTER_NAME_ORDER_INDEX_HOME,
    path: '/order/index',
    redirect: '/order/index',
    component: Layout,
    meta: {
      hasSubMenu: false,
      title: '续期订单',
      icon: 'icon-guanli',
      level: 1
    },
    children: [
      {
        name: RouteDefines.ROUTER_NAME_ORDER_INDEX_LIST,
        path: '/order/index',
        meta: {
          title: '续期订单',
          level: 2,
          menu_id: 10007,
          parent_name: RouteDefines.ROUTER_NAME_ORDER_INDEX_HOME
        },
        component: _import('order/index')
      }
    ]
  },
  // 素材管理
  {
    name: RouteDefines.ROUTER_NAME_MATERIAL_INDEX_HOME,
    path: '/material/index',
    redirect: '/material/index',
    component: Layout,
    meta: {
      hasSubMenu: false,
      title: '素材管理',
      icon: 'icon-guanli',
      level: 1
    },
    children: [
      {
        name: RouteDefines.ROUTER_NAME_MATERIAL_INDEX_LIST,
        path: '/material/index',
        meta: {
          title: '素材管理',
          level: 2,
          menu_id: 10008,
          parent_name: RouteDefines.ROUTER_NAME_MATERIAL_INDEX_HOME
        },
        component: _import('material/index')
      }
    ]
  },
  // 渠道管理
  {
    name: RouteDefines.ROUTER_NAME_CHANNEL_INDEX_HOME,
    path: '/channel/index',
    redirect: '/channel/index',
    component: Layout,
    meta: {
      hasSubMenu: false,
      title: '渠道管理',
      icon: 'icon-guanli',
      level: 1
    },
    children: [
      {
        name: RouteDefines.ROUTER_NAME_CHANNEL_INDEX_LIST,
        path: '/channel/index',
        meta: {
          title: '渠道管理',
          level: 2,
          menu_id: 10009,
          parent_name: RouteDefines.ROUTER_NAME_CHANNEL_INDEX_HOME
        },
        component: _import('channel/index')
      },

      {
        name: RouteDefines.ROUTER_NAME_WXXCX_TESTER_LIST,
        path: '/channel/:id/tester',
        meta: {
          title: '体验者列表',
          level: 2,
          menu_id: 100090,
          parent_name: RouteDefines.ROUTER_NAME_CHANNEL_INDEX_HOME
        },
        component: _import('wxxcx/tester')
      },

      {
        name: RouteDefines.ROUTER_NAME_WXXCX_CODE_TEMPLATE_LIST,
        path: '/channel/codetemplate',
        meta: {
          title: '代码管理',
          level: 2,
          menu_id: 100091,
          parent_name: RouteDefines.ROUTER_NAME_CHANNEL_INDEX_HOME
        },
        component: _import('wxxcx/code_template')
      },

      {
        name: RouteDefines.ROUTER_NAME_WXXCX_CODE_COMMIT_LIST,
        path: '/channel/:id/codecommit',
        meta: {
          title: '发布体验版',
          level: 2,
          menu_id: 100092,
          parent_name: RouteDefines.ROUTER_NAME_CHANNEL_INDEX_HOME
        },
        component: _import('wxxcx/code_commit')
      },

      {
        name: RouteDefines.ROUTER_NAME_WXXCX_CODE_SUBMIT_AUDIT_LIST,
        path: '/channel/:id/codesubmitaudit',
        meta: {
          title: '发布正式版',
          level: 2,
          menu_id: 100093,
          parent_name: RouteDefines.ROUTER_NAME_CHANNEL_INDEX_HOME
        },
        component: _import('wxxcx/code_submitaudit')
      }
    ]
  },
  {
    path: '*',
    name: 'ALL',
    redirect: '/404',
    meta: {
      hasSubMenu: false,
      hidden: true,
      title: '404'
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/menulist.js